import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import { OutboundLink } from 'gatsby-plugin-gtag';
import YoutubeVideoUser from 'components/Motion_Detection/INSTAR_Cloud/Create_User_Account/YoutubeVideoCardCloud';
import YoutubeVideoMDA from 'components/Web_User_Interface/1440p_Series/Alarm/Areas/YoutubeVideoCard';
import NavButtons from 'components/Motion_Detection/INSTAR_Cloud/NavButtons';
import ForumBox from 'components/Motion_Detection/INSTAR_Cloud/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  OutboundLink,
  YoutubeVideoUser,
  YoutubeVideoMDA,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};